/* Maritime chokepoints panel
   Fetches ships.json (counts + vessel dots per zone) and chokepoints-geo.json (coastlines),
   draws a world overview with one bubble per zone; click a zone to see its vessels. */
(function () {
    const root = document.querySelector('[data-chokepoints]');
    if (!root) return;

    const NS = 'http://www.w3.org/2000/svg';
    const feedUrl = root.dataset.feed;
    const geoUrl = root.dataset.geo;
    const refreshMs = Math.max(60, parseInt(root.dataset.refresh, 10) || 300) * 1000;
    const mapEl = root.querySelector('[data-cp-map]');
    const listEl = root.querySelector('[data-cp-list]');
    const legendEl = root.querySelector('[data-cp-legend]');
    const updatedEl = root.querySelector('[data-cp-updated]');
    const captionEl = root.querySelector('[data-cp-caption]');
    const backBtn = root.querySelector('[data-cp-back]');
    const windowEl = root.querySelector('[data-cp-window]');
    const compact = root.classList.contains('is-compact');   // shown inside the hero image
    const mapMaxH = compact ? 200 : 460;
    const toggleBtn = root.querySelector('[data-cp-toggle]');
    const headerEl = root.querySelector('.gh-cp-header');

    const CLASSES = [
        { key: 't', label: 'Tankers', field: 'tankers' },
        { key: 'c', label: 'Cargo', field: 'cargo' },
        { key: 'o', label: 'Other', field: 'other' },
        { key: 'u', label: 'Type unknown', field: 'unknown' }
    ];

    let geo = null, data = null, selected = 'world', timer = null;

    function svg(tag, attrs, parent) {
        const n = document.createElementNS(NS, tag);
        for (const k in attrs) n.setAttribute(k, attrs[k]);
        if (parent) parent.appendChild(n);
        return n;
    }
    function h(tag, cls, text, parent) {
        const n = document.createElement(tag);
        if (cls) n.className = cls;
        if (text != null) n.textContent = text;
        if (parent) parent.appendChild(n);
        return n;
    }
    function px(view, lat, lon) {
        const b = view.bbox; // [south, west, north, east]
        return [(lon - b[1]) / (b[3] - b[1]) * view.W, (b[2] - lat) / (b[2] - b[0]) * view.H];
    }
    function ago(iso) {
        const t = Date.parse(iso);
        if (isNaN(t)) return '';
        const m = Math.max(0, Math.round((Date.now() - t) / 60000));
        if (m < 1) return 'just now';
        if (m < 60) return m + ' min ago';
        const hr = Math.round(m / 60);
        return hr < 24 ? hr + ' h ago' : Math.round(hr / 24) + ' d ago';
    }
    const fmt = function (n) { return n.toLocaleString('en-US'); };
    // "Strait of Hormuz" -> "Hormuz", "Malacca & Singapore" -> "Malacca" (used for the compact chips)
    function shortName(n) {
        return n.replace(/^Strait of /, '').replace(/ (Canal|Straits?)$/, '').replace(/ & .*$/, '');
    }

    function zoneById(id) {
        return data.zones.find(function (z) { return z.id === id; });
    }

    function select(id) {
        selected = id;
        render();
    }

    function activate(node, id) {
        node.addEventListener('click', function () { select(id); });
        node.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(id); }
        });
    }

    function drawWorld() {
        const v = geo.world;
        const s = svg('svg', { viewBox: '0 0 ' + v.W + ' ' + v.H, role: 'img',
            'aria-label': 'World map with vessel counts at key chokepoints', class: 'gh-cp-svg' });
        svg('path', { d: v.d, class: 'gh-cp-land' }, s);
        data.zones.forEach(function (z) {
            const g = geo.zones[z.id];
            if (!g) return;
            const c = g.count; // [s, w, n, e]
            const p = px(v, (c[0] + c[2]) / 2, (c[1] + c[3]) / 2);
            const r = Math.min(17, 5 + 1.6 * Math.sqrt(z.vessels));
            const grp = svg('g', { class: 'gh-cp-bubble', tabindex: '0', role: 'button',
                'aria-label': z.name + ': ' + z.vessels + ' vessels' }, s);
            svg('title', {}, grp).textContent = z.name + ' - ' + z.vessels + ' vessels';
            svg('circle', { cx: p[0], cy: p[1], r: r }, grp);
            const t = svg('text', { x: p[0], y: p[1] + 1, class: 'gh-cp-bubble-n' }, grp);
            t.textContent = z.vessels;
            activate(grp, z.id);
        });
        mapEl.appendChild(s);
    }

    function drawZone(z) {
        const v = geo.zones[z.id];
        const s = svg('svg', { viewBox: '0 0 ' + v.W + ' ' + v.H, role: 'img',
            'aria-label': z.name + ': ' + z.vessels + ' vessels', class: 'gh-cp-svg is-zone' });
        // size the map to its own proportions (max 460px tall) so there are no empty side bars
        s.style.maxWidth = Math.round(mapMaxH * v.W / v.H) + 'px';
        s.style.margin = '0 auto';
        svg('path', { d: v.d, class: 'gh-cp-land' }, s);
        const a = px(v, v.count[2], v.count[1]), b = px(v, v.count[0], v.count[3]);
        svg('rect', { x: a[0], y: a[1], width: b[0] - a[0], height: b[1] - a[1], class: 'gh-cp-box' }, s);
        z.ships.forEach(function (sh) {
            const p = px(v, sh[0], sh[1]);
            if (p[0] < 0 || p[1] < 0 || p[0] > v.W || p[1] > v.H) return;
            const c = svg('circle', { cx: p[0].toFixed(1), cy: p[1].toFixed(1), r: compact ? 6 : 3.4, class: 'gh-cp-ship is-' + sh[2] }, s);
            const kind = CLASSES.filter(function (k) { return k.key === sh[2]; })[0];
            svg('title', {}, c).textContent = (sh[4] || 'Unnamed vessel') +
                (kind ? ' - ' + kind.label.replace(/s$/, '').toLowerCase() : '') +
                (sh[3] != null ? ' - ' + sh[3] + ' kn' : '');
        });
        mapEl.appendChild(s);
    }

    function drawLegend(zones) {
        legendEl.textContent = '';
        CLASSES.forEach(function (k) {
            const n = zones.reduce(function (a, z) { return a + (z[k.field] || 0); }, 0);
            const li = h('li', 'gh-cp-legend-item', null, legendEl);
            h('span', 'gh-cp-swatch is-' + k.key, null, li);
            li.appendChild(document.createTextNode(k.label + ' ' + fmt(n)));
        });
    }

    function drawList() {
        listEl.textContent = '';
        const max = Math.max.apply(null, data.zones.map(function (z) { return z.vessels; }).concat([1]));
        data.zones.forEach(function (z) {
            const li = h('li', null, null, listEl);
            const b = h('button', 'gh-cp-row' + (z.id === selected ? ' is-selected' : ''), null, li);
            b.type = 'button';
            h('span', 'gh-cp-row-name', compact ? shortName(z.name) : z.name, b);
            b.title = z.name;
            h('span', 'gh-cp-row-n', fmt(z.vessels), b);
            const bar = h('span', 'gh-cp-row-bar', null, b);
            CLASSES.forEach(function (k) {
                const w = (z[k.field] || 0) / max * 100;
                if (w > 0) {
                    const seg = h('span', 'gh-cp-seg is-' + k.key, null, bar);
                    seg.style.width = w + '%';
                }
            });
            h('span', 'gh-cp-row-sub', z.tankers ? fmt(z.tankers) + ' tankers' : 'no tankers seen', b);
            activate(b, z.id === selected ? 'world' : z.id);
        });
    }

    function render() {
        if (!geo || !data) return;
        if (selected !== 'world' && !zoneById(selected)) selected = 'world';
        mapEl.textContent = '';
        const z = selected === 'world' ? null : zoneById(selected);
        if (z && geo.zones[z.id]) {
            drawZone(z);
            drawLegend([z]);
            captionEl.textContent = z.name + ' - ' + fmt(z.vessels) + ' vessels';
            backBtn.hidden = false;
        } else {
            drawWorld();
            drawLegend(data.zones);
            captionEl.textContent = compact ? 'Vessels per zone - select one for detail'
                : 'Bubble size = vessels in zone. Select a zone for detail.';
            backBtn.hidden = true;
        }
        drawList();
        tick();
        root.hidden = false;
    }

    function tick() {
        if (!data) return;
        const stale = Date.now() - Date.parse(data.updated) > 45 * 60000;
        updatedEl.textContent = (stale ? 'Data delayed - ' : 'Updated ') + ago(data.updated);
        updatedEl.classList.toggle('is-stale', stale);
        if (windowEl && data.window_minutes) windowEl.textContent = data.window_minutes;
    }

    function load() {
        const jobs = [fetch(feedUrl, { cache: 'no-store', credentials: 'omit' }).then(function (r) {
            if (!r.ok) throw new Error(r.status);
            return r.json();
        })];
        if (!geo) {
            jobs.push(fetch(geoUrl).then(function (r) {
                if (!r.ok) throw new Error(r.status);
                return r.json();
            }));
        }
        Promise.all(jobs).then(function (res) {
            if (!res[0] || !Array.isArray(res[0].zones) || !res[0].zones.length) return;
            data = res[0];
            if (res[1]) geo = res[1];
            render();
        }).catch(function () { /* keep what is on screen; retry next cycle */ });
    }

    function start() { load(); timer = setInterval(load, refreshMs); }

    backBtn.addEventListener('click', function () { select('world'); });

    // On phones the compact panel starts collapsed (to keep articles near the top); header toggles it.
    if (compact && headerEl) {
        headerEl.addEventListener('click', function () {
            if (!window.matchMedia('(max-width: 767px)').matches) return;
            const open = root.classList.toggle('is-open');
            if (toggleBtn) toggleBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
    }
    document.addEventListener('visibilitychange', function () {
        if (document.hidden) { clearInterval(timer); timer = null; }
        else if (!timer) { start(); }
    });
    setInterval(tick, 60000);
    start();
})();
